<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>
        Dados do registro
        <v-chip v-if="current.isento" color="warning" class="ml-3" small>Isento</v-chip>
      </v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <div class="d-flex align-center">
                <v-text-field label="Cliente" v-model="current.clientName" outlined dense disabled hide-details>
                </v-text-field>
                <v-btn icon class="ml-1" @click="showClient = !showClient">
                  <v-icon>{{ showClient ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="Plano" v-model="current.planName" outlined dense disabled hide-details>
              </v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select label="Status" v-model="current.status" :items="status" item-text="name" item-value="id"
                outlined dense disabled hide-details></v-select>
            </div>
          </div>

          <v-expand-transition>
            <div class="row" v-show="showClient" v-if="clientDetails">
              <div class="col-md-12 col-sm-1">
                <v-sheet elevation="5" class="pa-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon left>mdi-account-box</v-icon>
                    <span class="subtitle-1">Dados do Cliente</span>
                    <v-spacer></v-spacer>
                    <v-btn small text color="primary"
                      :href="$router.resolve(`/client/${current.clientId}`).href" target="_blank">
                      <v-icon left small>mdi-open-in-new</v-icon>Abrir cadastro
                    </v-btn>
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="CPF/CNPJ" v-model="clientDetails.register" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="Telefone" v-model="clientDetails.telephone" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="Celular" v-model="clientDetails.cellphone" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="Email" v-model="clientDetails.email" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field label="Logradouro" v-model="clientDetails.address" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field label="Número" v-model="clientDetails.addressNumber" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field label="Complemento" v-model="clientDetails.addressExtra" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field label="Bairro" v-model="clientDetails.addressNeighborhood" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field label="Cidade" v-model="clientDetails.city" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field label="Estado" v-model="clientDetails.province" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="País" v-model="clientDetails.country" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field label="CEP" v-model="clientDetails.zipcode" outlined dense disabled
                        hide-details></v-text-field>
                    </div>
                  </div>
                </v-sheet>
              </div>
            </div>
          </v-expand-transition>

          <div class="row">
            <div class="col-md-6 col-sm-1" v-if="events">
              <v-sheet elevation="5" class="pa-2">
                Eventos:
                <v-chip class="ma-2" color="error" text-color="white" @click="dialogEvents(11)">
                  <v-avatar left class="error darken-4">{{ computedBlockCount }}</v-avatar>Bloqueios
                </v-chip>
                <v-chip class="ma-2" color="primary" text-color="white" close close-icon="mdi-plus-circle"
                  @click:close="dialogCreateEvent(21)" @click="dialogEvents(21)">
                  <v-avatar left class="primary darken-4">{{ computedVisitCount }}</v-avatar>Visitas
                </v-chip>
                <v-chip class="ma-2" color="primary" text-color="white" close close-icon="mdi-plus-circle"
                  @click:close="dialogCreateEvent(22)" @click="dialogEvents(22)">
                  <v-avatar left class="primary darken-4">{{ computedCallCount }}</v-avatar>Chamadas
                </v-chip>
                <v-chip class="ma-2" color="primary" text-color="white" close close-icon="mdi-plus-circle"
                  @click:close="dialogCreateEvent(23)" @click="dialogEvents(23)">
                  <v-avatar left class="primary darken-4">{{ computedPonLosCount }}</v-avatar>PON
                </v-chip>
              </v-sheet>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-sheet elevation="5" class="pa-2">
                Tags:
                <v-chip v-for="item in tags" :key="item.name" class="ma-2" close @click:close="tagRemove(item.name)">
                  {{ item.name }}
                </v-chip>
                <v-chip @click="tagAdd()">+</v-chip>
              </v-sheet>
            </div>
          </div>

          <v-row>
            <v-col>
              <v-sheet elevation="5" class="pa-2">
                <v-tabs v-model="tab" grow class="mt-2">
                  <v-tab key="drop"> Drop </v-tab>
                  <v-tab key="dados"> Dados </v-tab>
                  <v-tab key="ip"> IP </v-tab>
                  <v-tab key="financeiro"> Financeiro </v-tab>
                  <v-tab key="suporte"> Suporte </v-tab>
                  <v-tab key="posvenda"> Pos-Venda </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item key="drop">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <div class="col-md-6 col-sm-1">
                            <v-text-field label="Logradouro" v-model="current.address" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Número" v-model="current.addressNumber" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Complemento" v-model="current.addressExtra" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Bairro" v-model="current.addressNeighborhood" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="Cidade" v-model="current.city" outlined dense disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="Estado" v-model="current.province" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="País" v-model="current.country" outlined dense disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="CEP" v-model="current.zipcode" outlined dense disabled></v-text-field>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="dados">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <div class="col-md-6 col-sm-1">
                            <v-text-field label="Serial" v-model="current.serial" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-6 col-sm-1">
                            <v-select label="NMS" v-model="current.nms" :items="nms" item-text="name" item-value="id"
                              outlined dense disabled></v-select>
                          </div>
                        </div>
                        <v-btn color="success" @click="loadPowers()">Histórico de potência</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="ip">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <div class="col-md-4 col-sm-1">
                            <v-text-field label="Usuário" v-model="current.username" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-4 col-sm-1">
                            <v-text-field label="Senha" v-model="current.password" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="IP" v-model="current.ipaddress" outlined dense disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Rede" v-model="current.netaddress" outlined dense
                              disabled></v-text-field>
                          </div>
                        </div>
                        <v-btn color="success" @click="loadConnections()">Histórico de conexões</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="financeiro">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="Mensalidade" v-model="current.price" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-text-field label="Vencimento" v-model="current.expires" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Taxa de Instalação" v-model="current.setupPrice" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field label="Parcelas da Instalação" v-model="current.setupSplit" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-2 col-sm-1">
                            <v-text-field v-model="computedSetup" label="Dia da Instalação" readonly outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-select label="Rateio" v-model="current.rateioEnabled" :items="rateioStatus"
                              item-text="name" item-value="value" outlined dense disabled hide-details></v-select>
                            <v-btn color="success" v-if="current.rateioEnabled == false"
                              @click="rateioSet()">Habilitar</v-btn>
                            <v-btn color="error" v-if="current.rateioEnabled == true"
                              @click="rateioUnset()">Desabilitar</v-btn>
                          </div>
                          <div class="col-md-3 col-sm-1">
                            <v-select label="Isento" v-model="current.isento" :items="isentoStatus" item-text="name"
                              item-value="value" outlined dense disabled hide-details></v-select>
                            <v-btn color="success"
                              v-if="current.isento == false && ($auth.isSubusername('diego') || !$auth.isSubuser())"
                              @click="isentoSet()">Isentar</v-btn>
                            <v-btn color="error"
                              v-if="current.isento == true && ($auth.isSubusername('diego') || !$auth.isSubuser())"
                              @click="isentoUnset()">Desisentar</v-btn>
                          </div>
                          <div class="col-md-3 col-sm-1" v-if="current.status == 4">
                            <v-text-field label="Data do Cancelamento" v-model="computedCancelDay" outlined dense
                              disabled></v-text-field>
                          </div>
                          <div class="col-md-3 col-sm-1" v-if="current.status == 4">
                            <v-select label="Categoria do Cancelamento" v-model="current.cancelCategory"
                              :items="cancelCategories" item-text="name" item-value="id" outlined dense
                              disabled></v-select>
                          </div>
                          <div class="col-md-6 col-sm-1" v-if="current.status == 4">
                            <v-text-field label="Motivo do Cancelamento" v-model="current.cancelReason" outlined dense
                              disabled></v-text-field>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="suporte">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <div class="col-md-12 col-sm-1">
                            <v-textarea label="Observações" v-model="current.obs" outlined dense readonly
                              auto-grow></v-textarea>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="posvenda">
                    <v-card flat>
                      <v-card-text>
                        <div class="row">
                          <v-col>
                            <v-alert dense text color="default" icon="mdi-arrow-down">
                              Solicitar contato
                            </v-alert>
                            <div style="margin-bottom: 16px;">
                              <v-select label="Tipo de Contato" v-model="currentContact.type" :items="contactTypes"
                                item-text="name" item-value="id" outlined dense hide-details></v-select>
                            </div>
                            <div>
                              <v-textarea label="Orientações" v-model="currentContact.orientation" outlined dense
                                rows="6"></v-textarea>
                            </div>
                            <div>
                              <v-menu v-model="menu_contact_day" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field v-model="computedChangedContactDay" label="Dia do Contato" readonly
                                    v-bind="attrs" v-on="on" outlined dense></v-text-field>
                                </template>
                                <v-date-picker v-model="currentContact.expires" @input="menu_contact_day = false"
                                  locale="pt-br"></v-date-picker>
                              </v-menu>
                            </div>
                            <v-btn color="success" @click="contactRequest()">Solicitar contato</v-btn>
                          </v-col>
                          <v-col>
                            <v-alert dense text color="default" icon="mdi-arrow-down">
                              Contatos anteriores
                            </v-alert>
                            <v-alert v-for="item in contacts" :key="item.id" dense text :color="scoreColor(item.score)"
                              :icon="scoreIcon(item.score)">
                              <div>{{ item.contactTypeName }} - {{ item.expires | formatDate }}</div>
                              <div v-if="item.request">Orientação: {{ item.request | formatResponse }}</div>
                              <div v-if="item.response">Resposta: {{ item.response | formatResponse }}</div>
                            </v-alert>
                          </v-col>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-sheet>
            </v-col></v-row>

        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn v-if="current.status > 0 && current.status < 4" color="success" @click="dialogStatusUnblock()" class="ma-2">Desbloquear</v-btn>
          <v-btn v-if="current.status == 0" color="error" @click="dialogStatusBlock()" class="ma-2">Bloquear</v-btn>
          <v-btn v-if="current.status < 4" color="secondary" @click="dialogStatusCancel()" class="ma-2">Cancelar</v-btn>
          <v-btn v-if="current.status == 4" color="secondary" @click="dialogStatusUncancel()" class="ma-2">Descancelar</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogClient()" color="primary" class="ma-2">Mudança de Titularidade</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogPlan()" color="primary" class="ma-2">Mudança de Plano</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogSerial()" color="primary" class="ma-2">Trocar ONU</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogAuth()" color="primary" class="ma-2">Trocar Autenticação</v-btn>
          <v-btn v-if="current.status < 4" @click="dialogIP()" color="primary" class="ma-2">Trocar IP</v-btn>
          <v-btn v-if="current.status == 4 && current.ipaddress != ''" @click="dialogRemoveIP()" color="error" class="ma-2">Remover IP</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogAddress()" color="primary" class="ma-2">Mudança de Endereço</v-btn>
          <v-btn v-if="current.status == 0" @click="dialogObs()" color="primary" class="ma-2">Alterar Observações</v-btn>
          <v-btn v-if="current.serial != ''" @click="dialogONU()" color="secondary" class="ma-2">Devolução de ONU</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_block" width="300">
      <v-card>
        <v-card-title>Bloqueio de Internet</v-card-title>
        <v-card-text>
          <v-select label="Status" v-model="changed.status" :items="statusBlocks" item-text="name" item-value="id"
            outlined dense></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="putStatusBlock()">Bloquear</v-btn>
          <v-btn color="default" @click="dialog_status_block = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_unblock" width="300">
      <v-card>
        <v-card-title>Desbloqueio de Internet</v-card-title>
        <v-card-text>
          Tem certeza que deseja desbloquear o serviço de internet?
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putStatusUnblock()">Desbloquear</v-btn>
          <v-btn color="default" @click="dialog_status_unblock = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_cancel" width="400">
      <v-card>
        <v-card-title>Cancelamento de Internet</v-card-title>
        <v-card-text>
          <v-select label="Categoria" v-model="changed.cancelCategory" :items="cancelCategories"
            item-text="name" item-value="id" outlined dense></v-select>
          <v-text-field label="Motivo" v-model="changed.cancelReason" outlined dense></v-text-field>
          <v-menu v-model="menu_cancel_day" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedChangedCancelDay" label="Dia do Cancelamento" readonly v-bind="attrs"
                v-on="on" outlined dense></v-text-field>
            </template>
            <v-date-picker v-model="changed.cancelDay" @input="menu_cancel_day = false" locale="pt-br"></v-date-picker>
          </v-menu>
          <v-alert type="error">Atenção: tem certeza que deseja CANCELAR o serviço de internet?</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="putStatusCancel()">Cancelar internet</v-btn>
          <v-btn color="default" @click="dialog_status_cancel = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_uncancel" width="400">
      <v-card>
        <v-card-title>Descancelamento de Internet</v-card-title>
        <v-card-text>
          <v-alert type="error">Atenção: tem certeza que deseja DESCANCELAR o serviço de internet?</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="putStatusUncancel()">Descancelar internet</v-btn>
          <v-btn color="default" @click="dialog_status_uncancel = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_onu" width="400">
      <v-card>
        <v-card-title>Devolução de ONU</v-card-title>
        <v-card-text>
          Tem certeza que deseja fazer a devolução da ONU?
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="putONU()">Devolução</v-btn>
          <v-btn color="default" @click="dialog_onu = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_address" max-width="600px">
      <v-card>
        <v-card-title>Alterar Endereço do DROP</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Logradouro" v-model="changed.address" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Número" v-model="changed.addressNumber" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Complemento" v-model="changed.addressExtra" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Bairro" v-model="changed.addressNeighborhood" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Cidade" v-model="changed.city" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Estado" v-model="changed.province" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Pais" v-model="changed.country" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="CEP" v-model="changed.zipcode" outlined dense></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAddress()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_address = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="1000px">
      <v-card>
        <v-card-title>Alterar Observação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-textarea label="Observações" v-model="changed.obs" outlined dense rows="15"></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_serial" max-width="500px">
      <v-card>
        <v-card-title>Trocar ONU</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Serial" v-model="changed.serial" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select label="NMS" v-model="changed.nms" :items="nms" item-text="name" item-value="id" outlined
              dense></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putSerial()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_serial = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_auth" max-width="500px">
      <v-card>
        <v-card-title>Trocar Autenticação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Usuário" v-model="changed.username" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Senha" v-model="changed.password" outlined dense></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAuth()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_auth = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ip" max-width="500px">
      <v-card>
        <v-card-title>Trocar IP</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="IP" v-model="changed.ipaddress" outlined dense></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Rede" v-model="changed.netaddress" outlined dense></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putIP()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_ip = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ip_remove" max-width="500px">
      <v-card>
        <v-card-title>Remover IP</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="IP" v-model="current.ipaddress" outlined dense readonly></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Rede" v-model="current.netaddress" outlined dense readonly></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            Tem certeza que deseja remover o IP e a rede deste registro?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="removeIP()">Remover</v-btn>
          <v-btn color="default" @click="dialog_ip_remove = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_client" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Titular</v-card-title>
        <v-card-text>
          <v-autocomplete label="Cliente" v-model="changed.clientId" :search-input.sync="searchClient" :items="clients"
            item-text="name" item-value="id" outlined dense @change="changeClient"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putClient()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_client = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_plan" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Plano</v-card-title>
        <v-card-text>
          <v-autocomplete label="Plano" v-model="changed.planId" :search-input.sync="searchPlan" :items="plans"
            item-text="name" item-value="id" outlined dense @change="changePlan"></v-autocomplete>
          <v-text-field label="Mensalidade" v-model="changed.price" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putPlan()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_plan = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_connections" width="80%">
      <v-card>
        <v-card-title>Histórico de Conexões</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Dispositivo</th>
                <th>NAS</th>
                <th>Início</th>
                <th>Fim</th>
                <th>Entrada</th>
                <th>Saída</th>
                <th>Duração</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in connections" :key="item.id">
                <td>{{ item.username }}</td>
                <td>
                  {{ item.framedIpAddress }}
                </td>
                <td>
                  {{ item.nas }}
                </td>
                <td>
                  {{ item.start | formatDate }} <br />
                  {{ item.start | formatTime }}
                </td>
                <td>
                  {{ item.stop | formatDate }} <br />
                  {{ item.stop | formatTime }}
                </td>
                <td>{{ (item.inputOctets / 1024 / 1024).toFixed(3) }} MB</td>
                <td>{{ (item.outputOctets / 1024 / 1024).toFixed(3) }} MB</td>
                <td>{{ item.duration }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>Total</th>
                <th>{{ (totalInput / 1024 / 1024).toFixed(3) }} MB</th>
                <th>{{ (totalOutput / 1024 / 1024).toFixed(3) }} MB</th>
                <th>&nbsp;</th>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="dialog_connections = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <power-history-dialog v-model="dialog_powers" :powers="powers"></power-history-dialog>

    <v-dialog v-model="dialog_events" width="40%">
      <v-card>
        <v-card-title>Histórico de Eventos</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Horário</th>
                <th>Tipo</th>
                <th>Comentário</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in eventsFiltered" :key="item.id">
                <td>{{ item.time | formatDate }} {{ item.time | formatTime }}</td>
                <td>{{ item.entityEventType | formatEventType }}</td>
                <td>{{ item.data }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="dialog_events = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_event_create" max-width="500px">
      <v-card>
        <v-card-title>Novo evento</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-select label="Tipo de Evento" v-model="currentEvent.entityEventType" :items="eventType" item-value="id"
              item-text="value" outlined dense readonly></v-select>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-textarea label="Comentário" v-model="currentEvent.data" outlined dense></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="postEvent()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_event_create = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" color="success">
      Salvo com sucesso!
    </v-snackbar>

  </div>
</template>

<script>
import api from "../../api/index.js";
import PowerHistoryDialog from "../../components/PowerHistoryDialog.vue";
export default {
  components: { PowerHistoryDialog },
  data: () => ({
    current: null,
    clientDetails: null,
    showClient: false,
    currentEvent: {},
    events: [],
    eventType: [
      { id: 11, value: "Bloqueio" },
      { id: 12, value: "Desbloqueio" },
      { id: 13, value: "Cancelamento" },
      { id: 21, value: "Visita" },
      { id: 22, value: "Chamada" },
      { id: 23, value: "PON" }
    ],
    eventsFiltered: [],
    connections: [],
    powers: [],
    changed: {
      setup: null,
    },
    tab: null,
    snackbar: false,
    clients: [],
    searchClient: null,
    plans: [],
    searchPlan: null,
    nms: [],
    contacts: [],
    contactTypes: [],
    currentContact: {
      type: 5,
      orientation: '',
      expires: null
    },
    status: [
      { id: 0, name: "Habilitado" },
      { id: 1, name: "Bloqueado administrador" },
      { id: 2, name: "Bloqueado cliente" },
      { id: 3, name: "Bloqueado pagamento" },
      { id: 4, name: "Cancelado" },
    ],
    statusBlocks: [
      { id: 1, name: "Bloqueado administrador" },
      { id: 2, name: "Bloqueado cliente" },
      { id: 3, name: "Bloqueado pagamento" },
    ],
    cancelCategories: [
      { id: 0, name: "Desconhecida" },
      { id: 1, name: "Financeiro" },
      { id: 2, name: "Mudança" },
      { id: 3, name: "Concorrência" },
      { id: 4, name: "Insatisfação" },
      { id: 5, name: "Encerramento de atividade" },
      { id: 6, name: "Temporário" },
      { id: 7, name: "Pessoal" },
      { id: 8, name: "Interna" },
      { id: 9, name: "Outros" },
      { id: 10, name: "Sem viabilidade" },
      { id: 11, name: "Sem utilização" },
    ],
    rateioStatus: [
      { value: true, name: "Habilitado" },
      { value: false, name: "Desabilitado" },
    ],
    isentoStatus: [
      { value: true, name: "Sim" },
      { value: false, name: "Não" },
    ],
    dialog_loading: false,
    dialog_status_block: false,
    dialog_status_unblock: false,
    dialog_status_cancel: false,
    dialog_status_uncancel: false,
    dialog_address: false,
    dialog_obs: false,
    dialog_serial: false,
    dialog_auth: false,
    dialog_ip: false,
    dialog_ip_remove: false,
    dialog_onu: false,
    dialog_client: false,
    dialog_plan: false,
    dialog_connections: false,
    dialog_powers: false,
    dialog_events: false,
    dialog_event_create: false,
    menu_cancel_day: false,
    menu_contact_day: false,
  }),
  created: function () {
    this.load();
    this.loadNMS();
    this.loadEvents();
    this.loadContacts();
    this.loadContactTypes();
  },
  methods: {
    loadContacts: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/internet/contacts/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.contacts = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar contacts!");
          console.log(error);
        });
    },
    loadContactTypes: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/internet/contact_types", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.contactTypes = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar contact types!");
          console.log(error);
        });
    },
    loadNMS: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nms", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.nms = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar NMS!");
          console.log(error);
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/internet/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.loadClient();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    loadClient: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/client/" + this.current.clientId, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clientDetails = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar dados do cliente!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    dialogPlan: function () {
      this.plans = [{ id: this.current.planId, name: this.current.planName }];
      this.changed.planId = this.current.planId;
      this.changed.price = this.current.price;
      this.dialog_plan = true;
    },
    changePlan: function () {
      var planid = this.current.planId;
      for (var i = 0; i < this.plans.length; i++) {
        var plan = this.plans[i];
        if (plan.id == planid) {
          this.current.price = plan.price;
        }
      }
    },
    putPlan: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/plan/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_plan = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar plano!");
          console.log(error);
        });
    },
    dialogClient: function () {
      this.clients = [{ id: this.current.clientId, name: this.current.clientName }];
      this.changed.clientId = this.current.clientId;
      this.dialog_client = true;
    },
    changeClient: function () {
      var clid = this.current.clientId;
      for (var i = 0; i < this.clients.length; i++) {
        var cli = this.clients[i];
        if (cli.id == clid) {
          /*
          this.current.address = cli.address;
          this.current.addressNumber = cli.addressNumber;
          this.current.addressExtra = cli.addressExtra;
          this.current.addressNeighborhood = cli.addressNeighborhood;
          this.current.city = cli.city;
          this.current.province = cli.province;
          this.current.country = cli.country;
          this.current.zipcode = cli.zipcode;
          */
          break;
        }
      }
    },
    putClient: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/client/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_client = false;
          me.snackbar = true;
          me.current = response.data;
          me.loadClient();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar cliente!");
          console.log(error);
        });
    },
    tagRemove: function (tag) {
      var ntags = "";
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != tag) {
          ntags += tgs[i] + " ";
        }
      }
      this.current.tags = ntags.trim();
      this.putTags();
    },
    tagAdd: function () {
      var tg = prompt("Digite a tag: ");
      if (tg) {
        this.current.tags = this.current.tags + " " + tg;
        this.putTags();
      }
    },
    putTags: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.tags = this.current.tags;
      api
        .put("/internet/tags/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar tags!");
          console.log(error);
        });
    },
    dialogStatusBlock: function () {
      this.changed.status = this.current.status;
      this.dialog_status_block = true;
    },
    putStatusBlock: function () {
      var me = this;
      var token = localStorage.getItem("token");
      if (this.changed.status < 1 || this.changed.status > 3) {
        alert("Selecione um status válido!");
        return;
      }
      me.dialog_loading = true;
      api
        .put("/internet/block/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_block = false;
          alert("Bloqueio feito com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao bloquear!");
          console.log(error);
        });
    },
    dialogStatusUnblock: function () {
      this.dialog_status_unblock = true;
    },
    putStatusUnblock: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/unblock/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_unblock = false;
          alert("Desbloqueio de Internet feito com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao desbloquear Internet!");
          console.log(error);
        });
    },
    dialogStatusCancel: function () {
      this.changed.cancelCategory = 0;
      this.dialog_status_cancel = true;
    },
    putStatusCancel: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/cancel/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_cancel = false;
          alert("Internet CANCELADA com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao CANCELAR Internet!");
          console.log(error);
        });
    },
    dialogStatusUncancel: function () {
      this.dialog_status_uncancel = true;
    },
    putStatusUncancel: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/uncancel/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_uncancel = false;
          alert("Internet DESCANCELADA com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao DESCANCELAR Internet!");
          console.log(error);
        });
    },
    dialogAddress: function () {
      this.changed.address = this.current.address;
      this.changed.addressNumber = this.current.addressNumber;
      this.changed.addressExtra = this.current.addressExtra;
      this.changed.addressNeighborhood = this.current.addressNeighborhood;
      this.changed.city = this.current.city;
      this.changed.province = this.current.province;
      this.changed.country = this.current.country;
      this.changed.zipcode = this.current.zipcode;
      this.dialog_address = true;
    },
    putAddress: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/address/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_address = false;
          alert("Endereço alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar endereço!");
          console.log(error);
        });
    },
    dialogObs: function () {
      this.changed.obs = this.current.obs;
      this.dialog_obs = true;
    },
    putObs: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observação!");
          console.log(error);
        });
    },
    dialogSerial: function () {
      this.changed.serial = this.current.serial;
      this.changed.nms = this.current.nms;
      this.dialog_serial = true;
    },
    putSerial: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/serial/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_serial = false;
          alert("ONU alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar ONU!");
          console.log(error);
        });
    },
    dialogAuth: function () {
      this.changed.username = this.current.username;
      this.changed.password = this.current.password;
      this.dialog_auth = true;
    },
    putAuth: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/auth/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_auth = false;
          alert("Autenticação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar autenticação!");
          console.log(error);
        });
    },
    dialogIP: function () {
      this.changed.ipaddress = this.current.ipaddress;
      this.changed.netaddress = this.current.netaddress;
      this.dialog_ip = true;
    },
    putIP: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/ip/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_ip = false;
          alert("IP alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar IP!");
          console.log(error);
        });
    },
    dialogRemoveIP: function () {
      this.dialog_ip_remove = true;
    },
    removeIP: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.ipaddress = "";
      this.changed.netaddress = "";
      api
        .put("/internet/ip/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_ip_remove = false;
          alert("IP removido com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao remover IP!");
          console.log(error);
        });
    },
    dialogONU: function () {
      this.dialog_onu = true;
    },
    putONU: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/internet/backonu/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_onu = false;
          alert("ONU devolvida com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao devolver ONU!");
          console.log(error);
        });
    },
    loadConnections: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/internet/connections/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.connections = response.data;
          me.dialog_connections = true;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar conexões!");
          console.log(error);
        });
    },
    rateioSet: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.rateioEnabled = true;
      api
        .put("/internet/rateio/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_onu = false;
          alert("Rateio atualizado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao atualizar rateio!");
          console.log(error);
        });
    },
    rateioUnset: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.rateioEnabled = false;
      api
        .put("/internet/rateio/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_onu = false;
          alert("Rateio atualizado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao atualizar rateio!");
          console.log(error);
        });
    },
    isentoSet: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.isento = true;
      api
        .put("/internet/isento/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          alert("Isento atualizado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao atualizar isento!");
          console.log(error);
        });
    },
    isentoUnset: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.isento = false;
      api
        .put("/internet/isento/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          alert("Isento atualizado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao atualizar isento!");
          console.log(error);
        });
    },
    loadPowers: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/internet/powers/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.powers = response.data;
          me.dialog_powers = true;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar potencias!");
          console.log(error);
        });
    },
    loadEvents: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/event/internet/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.events = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar eventos!");
          console.log(error);
        });
    },
    dialogEvents: function (type) {
      this.eventsFiltered = [];
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].entityEventType == type) {
          this.eventsFiltered.push(this.events[i]);
        }
      }
      this.dialog_events = true;
    },
    dialogCreateEvent: function (type) {
      this.currentEvent = {
        entityEventType: type,
        data: ""
      };
      this.dialog_event_create = true;
    },
    postEvent: function () {
      var me = this;
      var token = localStorage.getItem("token");
      var evp = "";
      if (this.currentEvent.entityEventType == 21) {
        evp = "visit";
      } else if (this.currentEvent.entityEventType == 22) {
        evp = "call";
      } else if (this.currentEvent.entityEventType == 23) {
        evp = "ponlos";
      } else {
        alert("Tipo de evento invalido!");
        return;
      }
      if (this.currentEvent.data === "") {
        alert("Comentário não pode ser vazio!");
        return;
      }
      me.dialog_loading = true;
      api
        .post("/internet/" + evp + "/" + this.$route.params.id, this.currentEvent, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          me.dialog_event_create = false;
          alert("Evento cadastrado com sucesso!");
          me.loadEvents();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao cadastrar evento!");
          console.log(error);
        });
    },
    contactRequest: function () {
      var me = this;
      var token = localStorage.getItem("token");
      if (this.currentContact.expires === null) {
        alert("Dia não pode ser vazio!");
        return;
      }
      if (this.currentContact.orientation === "") {
        alert("Orientação não pode ser vazio!");
        return;
      }
      me.dialog_loading = true;
      api
        .post("/internet/contacts/" + this.$route.params.id, this.currentContact, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Contato cadastrado com sucesso!");
          me.currentContact = {
            type: 5,
            orientation: '',
            expires: null
          };
          me.loadContacts();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao cadastrar contato!");
          console.log(error);
        });
    },
    scoreIcon: function (score) {
      return "mdi-numeric-" + score + "-box";
    },
    scoreColor: function (score) {
      var ret = "default";
      if (score < 7) {
        ret = "error";
      } else if (score < 9) {
        ret = "warning";
      } else {
        ret = "success";
      }
      return ret;
    }
  },
  computed: {
    computedBlockCount: function () {
      var count = 0;
      for (var i = 0; i < this.events.length; i++) {
        var evt = this.events[i];
        if (evt.entityEventType == 11) {
          count++;
        }
      }
      return count;
    },
    computedVisitCount: function () {
      var count = 0;
      for (var i = 0; i < this.events.length; i++) {
        var evt = this.events[i];
        if (evt.entityEventType == 21) {
          count++;
        }
      }
      return count;
    },
    computedCallCount: function () {
      var count = 0;
      for (var i = 0; i < this.events.length; i++) {
        var evt = this.events[i];
        if (evt.entityEventType == 22) {
          count++;
        }
      }
      return count;
    },
    computedPonLosCount: function () {
      var count = 0;
      for (var i = 0; i < this.events.length; i++) {
        var evt = this.events[i];
        if (evt.entityEventType == 23) {
          count++;
        }
      }
      return count;
    },
    computedSetup: function () {
      return this.formatDate(this.current.setup);
    },
    computedCancelDay: function () {
      return this.formatDate(this.current.cancelDay);
    },
    computedChangedCancelDay: function () {
      return this.formatDate(this.changed.cancelDay);
    },
    computedChangedContactDay: function () {
      return this.formatDate(this.currentContact.expires);
    },
    tags: function () {
      var ret = [];
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != "") {
          ret.push({ name: tgs[i] });
        }
      }
      return ret;
    },
    totalInput: function () {
      if (this.connections) {
        var sum = 0;
        var he;
        for (he of this.connections) {
          sum += he.inputOctets;
        }
        return sum;
      }
      return 0;
    },
    totalOutput: function () {
      if (this.connections) {
        var sum = 0;
        var he;
        for (he of this.connections) {
          sum += he.outputOctets;
        }
        return sum;
      }
      return 0;
    }
  },
  watch: {
    searchClient: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/client/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clients = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchPlan: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/plan/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.plans = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  filters: {
    formatEventType: function (val) {
      var ret = "desconhecido";
      if (val == 11) {
        ret = "Bloqueio";
      } else if (val == 12) {
        ret = "Desbloqueio";
      } else if (val == 13) {
        ret = "Cancelamento";
      } else if (val == 21) {
        ret = "Visita";
      } else if (val == 22) {
        ret = "Chamada";
      } else if (val == 23) {
        ret = "PON";
      }
      return ret;
    },
    formatResponse: function (response) {
      return response;
    },
  }
};
</script>